import React, { useEffect, useState } from 'react';
import { httpGet } from '../../helpers/httpHelper';
import authService from '../../api-authorization/AuthorizeService'
import './BiAutoCB.css';
const BiAutoCB = ({
    item,
    items,
    onItemSelected,
    name,
    width,
    disabled,
    placeholder,
    online,
    onlineID,
    style,
    skipAuth
}) => {
    let dod = {
        width: width == null ? "" : ((width) + "px")
    }
    const [suggestions, setSugsestions] = useState([]);
    const [text, setText] = useState("");

    const [active, setActive] = useState(0);

    let position = { x: 0, y: 0 };

    useEffect(() => {
        if (item != null) {

            setText(item.naziv != null ? item.naziv : "");
            setSugsestions([]);
        }
    }, [item]);
    const getCoords = (elem) => { // crossbrowser version
        var box = elem.getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var top = box.top + scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        return { top: Math.round(top), left: Math.round(left) };
    }
    const onTextChange = (e) => {

        var rec = getCoords(e.target);

        if (rec.left > 0) {
            position.x = rec.left;
            position.y = rec.top;

        }
        setText(e.target.value)
        setActive(0);
        let te = e.target.value;
        if (online && te == null) {
            te = "";
        }

        if (te != null && te.length > 0) {

            if (online) {

                if (skipAuth) {
                    httpGet("api/sifranti/GetSifrantNA", { id: onlineID, term: te }, (res) => {

                        setSugsestions(res);
                    }, null);
                }
                else {
                    httpGet("api/sifranti/GetSifrant", { id: onlineID, term: te }, (res) => {

                        setSugsestions(res);
                    }, authService);
                }
            }
            else {
                setSugsestions(items.sort().filter(v => v.naziv != null && v.naziv.toUpperCase().indexOf(te.toUpperCase()) > -1));
            }
        } else {
            if (online == false) {
                setSugsestions(items);
            } else {
                setSugsestions([]);
            }
        }


    }

    const clearSelection = () => {
        setSugsestions([]);
        setText("");
        if (onItemSelected != null) {
            onItemSelected({ target: { name: name, value: { id: null, naziv: null } } });
        }
    }

    const suggestionSelected = (val) => {
        setSugsestions([]);
        if (val != null) {
            setText(val.naziv);

            if (onItemSelected != null) {
                onItemSelected({ target: { name: name, value: val } });
            }
        }
    }

    const getPos = () => {


        return { position: "absolute", top: (position.x + "px"), left: (position.y + "px") };
    }

    const renderSuggestions = () => {
        if (suggestions.length === 0) {
            return null;
        }

        return (
            <ul>

                {suggestions.map((d, index) => {
                    var cla = (active == null ? "" : (active == index ? "selectedActive" : ""));

                    return (<li className={cla} key={name + "-" + d.id} onClick={(e) => suggestionSelected(d)}>{d.naziv}</li>)
                })

                }
            </ul>
        )

    }

    const onKeyDown = e => {
        if (e.keyCode === 40) {
            if (active < suggestions.length - 1) {
                setActive(active + 1);
            }
        }
        if (e.keyCode === 38) {
            if (active > 0) {
                setActive(active - 1);
            }
        }
        if (e.keyCode === 13 || e.keyCode === 9) {
            suggestionSelected(suggestions[active]);
        }
        if (e.keyCode === 27) {
            setSugsestions([]);
            setText("");
        }

        e.stopPropagation();
    }

    return (
        <div className="TypeAheadDropDown" style={{ ...dod, ...style }}>
            <input disabled={disabled} onKeyDown={onKeyDown} className="form-control form-control-sm biControlInline biInput" onClick={onTextChange} onChange={onTextChange} placeholder={placeholder != undefined ? placeholder : "Iskanje"} value={text} type="text" />

            {!disabled &&
                < a className="removeBTN" onClick={clearSelection}>x</a>
            }
            {renderSuggestions()}
        </div>
    );
}

export default BiAutoCB;